import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NProductConfiguration } from './df-module-product-configuration.interfaces';

import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

export function provideDfModuleProductConfiguration(config?: DeepPartial<NProductConfiguration.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: NProductConfiguration.OPTIONS,
            useFactory: () =>
                defaultsDeep(config || {}, <NProductConfiguration.IModuleOptions>{
                    bundle: {},
                    grouped: {
                        showOutOfStock: true,
                        sortBy: 'position',
                        minSelection: 1
                    },
                    configurable: {
                        order: [],
                        hashStorageLogic: 'value',
                        noHashOnInit: false,
                        optionsEngines: [],
                        selection: {
                            default: {
                                onMismatch: 'unselect',
                                onPartial: 'parent'
                            }
                        },
                        metaModel: 'none',
                        urlModel: 'none',
                        chooseChild: (matchResult, selection) => matchResult.children[0]
                    }
                })
        }
    ]);
}
